module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCIgdmlld0JveD0iMCAwIDE4IDE4Ij4KICAgIDxnIGZpbGw9IiNhNGIwYmYiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZmlsbC1ydWxlPSJub256ZXJvIiBkPSJNOSAxN0E4IDggMCAxIDAgOSAxYTggOCAwIDAgMCAwIDE2em0wIDFBOSA5IDAgMSAxIDkgMGE5IDkgMCAwIDEgMCAxOHoiLz4KICAgICAgICA8Y2lyY2xlIGN4PSI5IiBjeT0iOSIgcj0iNCIvPgogICAgPC9nPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/controls/radio-on.svg
// module id = ./src/assets/controls/radio-on.svg
// module chunks = 0